import * as React from 'react';
import {Formik, Form as FForm, FormikValues} from 'formik';

export interface FormProps {
  internalSubmitBtn?: boolean;
  initialValues?: any;
  validateOnChange?: boolean;
  validateOnBlur?: boolean;
  onSubmit?(values: any, data: any): void;
  onValidate?(validate: boolean, values: any): void;
  onValidating?(validating: boolean, validate: boolean): void;
  onReturnPress?(): void;
}

export abstract class Form<P extends FormProps, S> extends React.Component<P, S> {

  private oldValues: any = {};
  private oldErrors: any = {};

  protected constructor(props: P) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.emitEnterPress = this.emitEnterPress.bind(this);
    this.emitValidate = this.emitValidate.bind(this);
    this.emitValidating = this.emitValidating.bind(this);
  }

  protected abstract handleValidate(oldValues: any, oldErrors: any, values: any): any;
  protected abstract formRender(isSubmitting: boolean, values: FormikValues, errors: any): any;

  shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
    return false;
  }

  protected handleSubmit(values: any, data: any) {
    if (this.props.onSubmit) {
      this.props.onSubmit(values, data);
    }
  }

  protected emitValidate(validate: boolean, values: any) {
    if (this.props.onValidate) {
      this.props.onValidate(validate, values);
    }
  }

  protected emitValidating(validating: boolean, validate: boolean) {
    if (this.props.onValidating) {
      this.props.onValidating(validating, validate);
    }
  }

  protected emitResult(values: any, errors: any, resolve: any, reject: any) {
    const validate = Object.keys(errors).length == 0;
    if (!validate) {
      reject(errors);
    } else {
      resolve();
    }

    this.oldValues = values;
    this.oldErrors = errors;
    this.emitValidate(validate, { ...values });
    this.emitValidating(false, validate);
  }

  private emitEnterPress(event: any) {
    if (event.keyCode == 13 && this.props.onReturnPress) {
      this.props.onReturnPress();
    }
  }

  render() {
    return (
      <Formik initialValues={this.props.initialValues || {}} enableReinitialize={true}
              validate={values => this.handleValidate(this.oldValues, this.oldErrors, values)}
              onSubmit={this.handleSubmit} validateOnChange={true} validateOnBlur={false}>
        {({ isSubmitting, values, errors }) => (
          <FForm onKeyUp={this.emitEnterPress}>
            {this.formRender(isSubmitting, values, errors)}
          </FForm>
        )}
      </Formik>
    );
  }
}
